import React, { useEffect } from 'react';
import { PageLayout } from "../../layout/PageLayout/PageLayout";
import { useApplicationContext } from '../../application/ApplicationContext';
import './NewInvoicePage.scss';

const NewInvoicePage = () => {

    const { setBreadcrumb } = useApplicationContext();

    useEffect(() => {
        setBreadcrumb(['Fakture', 'Nova profaktura']);
    }, []);

    return (
        <PageLayout>
            <div className="new-invoice">
                NOVA PROFAKTURA
            </div>
        </PageLayout>
    );
};

export default NewInvoicePage;
